import {
  Button,
  CustomFilter,
  EllipsisSpan,
  FieldTable,
  Form,
  Input,
  Paging,
  PopConfirm,
  useBreadcrumbRoutes,
  usePaging,
  useUpdate,
  Wrapper,
} from '@maxtropy/components';
import { Space } from 'antd';
import { useRequest } from 'ahooks';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiV2AreaDeleteConfigPost, apiV2AreaGetConfigPagePost } from '@maxtropy/device-customer-apis-v2';
import dayjs from 'dayjs';
import { useHasPermission } from '@/utils/utils';
import { PermissionsType } from '@/common/permissionsConst';

const columns = [
  {
    title: '区域名称',
    dataIndex: 'areaName',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '关联用能单元',
    dataIndex: 'energyUnitName',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '最后操作时间',
    dataIndex: 'updateTime',
    ellipsis: { showTitle: true },
    render: (v: number) => <EllipsisSpan value={dayjs(v).format('YYYY-MM-DD')} />,
  },
  {
    title: '最后操作人',
    dataIndex: 'updater',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
];

const AreaConfig = () => {
  const [areaName, setAreaName] = useState<string>();

  const breadcrumbRoutes = useBreadcrumbRoutes();
  const [update, updateFn] = useUpdate();
  const pagingInfo = usePaging(50);
  const { pageOffset, pageSize, setTotalCount, setPageOffset } = pagingInfo;
  const navigate = useNavigate();
  const hasValveConfigBtn = useHasPermission(PermissionsType.B_VALVECONFIGURATION);
  const [form] = Form.useForm();

  const { data, loading } = useRequest(
    () =>
      apiV2AreaGetConfigPagePost({
        areaName,
        page: pageOffset,
        size: pageSize,
      }).then(res => {
        setTotalCount(res?.total ?? 0);
        return res.list || [];
      }),
    {
      refreshDeps: [pageOffset, pageSize, areaName, update],
    }
  );

  const onReset = () => {
    setAreaName('');
    setPageOffset(1);
  };
  const onFinish = (values: any) => {
    setAreaName(values.areaName);
    setPageOffset(1);
  };
  const deleteConfig = (id: number) => {
    apiV2AreaDeleteConfigPost({ id }).then(() => {
      updateFn();
    });
  };
  const buildColumns = [
    ...columns,
    {
      title: '操作',
      width: 180,
      render: (record: any) => {
        return (
          <Space size={16}>
            <Button type="link" onClick={() => navigate(`/area/config/page/detail/${record.id}?mode=view`)}>
              查看
            </Button>
            <Button type="link" onClick={() => navigate(`/area/config/page/detail/${record.id}?mode=edit`)}>
              编辑
            </Button>
            {hasValveConfigBtn && (
              <Button type="link" onClick={() => navigate(`/area/config/page/valveConfig/${record.id}`)}>
                阀门配置
              </Button>
            )}
            {!!record.isNeedMeterReading && (
              <Button type="link" onClick={() => navigate(`/area/config/page/linkedmeteringdevices/${record.areaId}`)}>
                关联抄表设备
              </Button>
            )}
            <PopConfirm title="删除后不可恢复，请确认是否删除？" onConfirm={() => deleteConfig(record.id)}>
              <Button type="link" danger>
                删除
              </Button>
            </PopConfirm>
          </Space>
        );
      },
    },
  ];
  const filters = (
    <CustomFilter form={form} onFinish={val => onFinish(val)} onReset={onReset}>
      <Form.Item name="areaName" label="区域名称">
        <Input placeholder="请输入区域名称" />
      </Form.Item>
    </CustomFilter>
  );
  return (
    <Wrapper routes={[...(breadcrumbRoutes?.routes ?? [])]} filters={filters}>
      <Space size={8} style={{ marginBottom: 10 }}>
        <Button type="primary" onClick={() => navigate('/area/config/page/create')}>
          新增区域配置
        </Button>
      </Space>
      <FieldTable rowKey="id" loading={loading} dataSource={data} columns={buildColumns} />
      <Paging pagingInfo={pagingInfo} />
    </Wrapper>
  );
};
export default AreaConfig;
